export const ColorChooser = ({
  colorVariants,
  onChange,
  onMouseEnter,
  onMouseLeave,
  activeColor,
}: {
  colorVariants: number[][][];
  onChange: (index: number) => void;
  onMouseEnter?: (index: number) => void;
  onMouseLeave?: (index: number) => void;
  activeColor: number;
}) =>
  colorVariants.map((colors, index) => (
    <div key={index}>
      <button
        style={{
          display: 'grid',
          gridTemplateColumns: '2fr 1fr',
          height: '30px',
          width: '100%',
          padding: 0,
          cursor: 'pointer',
          justifyContent: 'stretch',
          alignItems: 'stretch',
          border: containsWhite(colors)
            ? '1px solid var(--color-medium-light-grey)'
            : 'none',
        }}
        onClick={() => onChange(index)}
        onMouseEnter={() => (onMouseEnter ? onMouseEnter(index) : null)}
        onMouseLeave={() => (onMouseLeave ? onMouseLeave(index) : null)}
      >
        {colors.map((color, cIndex) => (
          <div
            key={cIndex}
            style={{
              backgroundColor: `rgba(${color.join(', ')})`,
              gridColumn: `${cIndex + 1} / ${colors.length === 1 ? 3 : cIndex + 2}`,
            }}
          />
        ))}
      </button>
      <div
        style={{
          height: '2px',
          backgroundColor:
            index === activeColor ? 'var(--color-light-red)' : 'transparent',
          marginTop: '8px',
        }}
      ></div>
    </div>
  ));

const containsWhite = (colors: number[][]) =>
  colors.some((c) => c.every((v) => v === 255));
